<template lang="html">
  <div class="donnut-chart-section" v-bind:class="{ printVersion: printVersion }">
    <donnut-component-d3 :uni_color="uniColor" :data-entry="donnutData" :labels-entry="donnutLabels" :colors="colors"></donnut-component-d3>
    <donnut-info :data="infoData"></donnut-info>
  </div>
</template>

<script>
import donnutComponentD3 from "./DonnutChartD3";
import donnutInfo from "./InfoListDonnut";
export default {
  name: "AssetAllocationSection",
  components: {
    donnutComponentD3: donnutComponentD3,
    donnutInfo: donnutInfo
  },
  props: {
    printableVersion: false,
    uniColor: {},
    donnutData: Array,
    infoData: Array,
    donnutLabels: Array,
    colors: Array
  },
  mounted() {
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data() {
    return {
      printVersion: false
    };
  }
};
</script>

<style scoped>
.donnut-chart-section {
  display: block;
  margin: 0 auto;
  max-width: 768px;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
  overflow: hidden;
  box-sizing: border-box;
}
.printVersion > .info-list-container {
  margin-top: -90px;
  top: 86px;
  transform: scale(0.9);
}
.printVersion > .chartwrapper {
  width: 500px;
  height: 220px;
  bottom: 75px;
  left: -34px;
}
</style>



// WEBPACK FOOTER //
// src/components/DonnutChartSection.vue